<ng-container
  [ngTemplateOutlet]="isMyPlan ? myPlanTemplate : allSubscriptionsTemplate"
></ng-container>

<!-- TEMPLATES -->
<ng-template #myPlanTemplate>
  <div class="border rounded-2 p-4 shadow-sm w-100 min-vh-65">
    <div class="d-flex flex-column gap-1">
      <div class="d-flex flex-column gap-2">
        <span class="subscription-title-color fs-3 fw-bolder">Pro</span>
        <span class="text-gray fs-4">Perfect for institutions with advanced needs</span>
      </div>
      <br>
      <div class="d-flex flex-row gap-1">
        <span class="subscription-title-color fs-2 fw-bolder">$29</span>
        <span class="subscription-title-color fs-3 fw-bold mt-1">/ per month</span>
      </div>
    </div>

    <br>
    <br>

    <div class="col-md-12 d-flex align-items-start">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Start Date</mat-label>
        <input matInput>
      </mat-form-field>
    </div>

    <br>

    <div class="col-md-12">
      <button class="btn btn-outline-primary w-100 rounded-5">Upgrade</button>
    </div>

  </div>
</ng-template>

<ng-template #allSubscriptionsTemplate>
  <div class="border rounded-2 p-5 shadow-sm w-100">
    <div class="d-flex flex-column gap-3">
      <div class="d-flex flex-column gap-4">
        <span class="subscription-title-color fs-2 fw-bolder">Title</span>
        <span class="text-gray fs-4">Description</span>
      </div>
      <br>
      <div class="d-flex flex-row gap-1">
        <span class="subscription-title-color fs-2 fw-bolder">$29</span>
        <span class="subscription-title-color fs-3 fw-bold mt-1">/ per month</span>
      </div>
    </div>

    <hr class="w-100 my-5">

    <div class="d-flex flex-column gap-2">
      <div class="d-flex flex-row gap-3 align-items-center">
        <mat-icon class="text-primary">check</mat-icon>
        <span class="fs-4 text-gray">Plan Feature</span>
      </div>
      <div class="d-flex flex-row gap-3 align-items-center">
        <mat-icon class="text-primary">check</mat-icon>
        <span class="fs-4 text-gray">Plan Feature</span>
      </div>
      <div class="d-flex flex-row gap-3 align-items-center">
        <mat-icon class="text-gray">close</mat-icon>
        <span class="fs-4 text-gray">Plan Feature</span>
      </div>
      <div class="d-flex flex-row gap-3 align-items-center">
        <mat-icon class="text-gray">close</mat-icon>
        <span class="fs-4 text-gray">Plan Feature</span>
      </div>
    </div>

    <br>
    <br>

    <button class="btn btn-primary w-100 rounded-5">Downgrade</button>

  </div>
</ng-template>
